import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  margin-bottom: ${props => props.theme.spacing.sp32};
`

export const NoResultsFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
  margin-top: 124px;
  text-align: center;
`

export const ActionButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
